import { FileExcelOutlined } from '@ant-design/icons'
import { Button, Typography } from 'antd'
import React from 'react'
import { useStableUsRestrictedDataAccess } from 'enrollment-platform/rbac/useStableUsRestrictedDataAccess'
import { useOepTargetFileJobs } from '../hooks/useOepTargetFileJobs'
import { OepTargetFileJobsTable } from './OepTargetFileJobsTable'

const { Title, Text } = Typography

interface Props {
  readonly clientId: string
}

export function OepTargetFileGenerationSection({ clientId }: Props) {
  // Both load and generate failures surface via toast (see useOepTargetFileJobs)
  // — no inline error UI here.
  const {
    latestJob,
    isLoading,
    isGenerating,
    isGenerateDisabled,
    handleGenerate,
    handleDownload,
  } = useOepTargetFileJobs({ clientId })
  // EMS-10969: the target file can reveal US-restricted (Kaiser) data; EPS
  // answers 403 without UsRestrictedData:Manage, so hide Generate + Download.
  const { hasUsRestrictedDataAccess } = useStableUsRestrictedDataAccess()

  return (
    <section id="oep-target-file-generation-section">
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Title level={5} style={{ marginTop: 0 }}>
            Generate target file
          </Title>
          <Text type="secondary">
            Generate an ABP target file workbook for this client. Only the most
            recent job is shown below.
          </Text>
        </div>
        {hasUsRestrictedDataAccess ? (
          <div>
            <Button
              id="oep-target-file-generate-btn"
              type="primary"
              icon={<FileExcelOutlined />}
              loading={isGenerating}
              disabled={isGenerateDisabled}
              onClick={() => void handleGenerate()}
            >
              Generate target file
            </Button>
          </div>
        ) : null}
      </div>
      <OepTargetFileJobsTable
        latestJob={latestJob}
        isLoading={isLoading}
        onDownload={handleDownload}
        showDownload={hasUsRestrictedDataAccess}
      />
    </section>
  )
}
